import React from 'react';
import PropTypes from 'prop-types';
import styles from './ToggleSwitch.module.scss';

const ToggleSwitch = ({ isOn, handleToggle, size, name, id }) => {
  return (
    <div className={`${styles.toggleSwitch} ${styles[size]}`} onClick={(e) => e.stopPropagation()}>
      <input
        checked={isOn}
        onChange={(e) => handleToggle(!isOn, name, id)}  // pass the name directly
        className={styles.reactSwitchCheckbox}
        id={`react-switch-${name}-${id}`}  // use name to make id unique
        type="checkbox"
        name={name}
      />
      <label
        className={styles.reactSwitchLabel}
        htmlFor={`react-switch-${name}-${id}`}
      >
        <span className={styles.reactSwitchButton} />
      </label>
    </div>
  );
};

ToggleSwitch.propTypes = {
  isOn: PropTypes.bool.isRequired,
  handleToggle: PropTypes.func.isRequired,
  size: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

export default ToggleSwitch;